export const getCarName = (modelName?: string | null) => {
  if (!modelName) return null;

  let initial = 2;
  if (modelName.substring(0, 2).trim().length === 2) {
    initial = 3;
  }

  if (modelName.slice(-10) === 'OR SIMILAR') {
    return `${modelName.slice(initial, -10)} 또는 동급차량`;
  }

  return modelName.slice(initial);
};
